import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useCookies } from "react-cookie";
import pic from "../assets/pinnacleWhiteLogo.svg";
import Header from "../components/Header/Header";
import { CgMenuGridO } from "react-icons/cg";
import { BsGooglePlay, BsFillMenuButtonWideFill } from "react-icons/bs";
import { HiOutlineBookOpen } from "react-icons/hi";
import { AiOutlineLineChart } from "react-icons/ai";
import ShareModal from "../components/ShareModalBook";
import { useLocation } from "react-router-dom";
import { MdOndemandVideo } from "react-icons/md";
import { ImBlogger } from "react-icons/im";
import testSeries from "../assets/testseries1.png";
import video from "../assets/video.png";
import ebooks from "../assets/ebooks.png";
import google from "../assets/google.svg";
import book from "../assets/booksIcon.png";
import blog from "../assets/Blog.png";
import playIcon from "../assets/googleplayIcon.png";
import EbookOfferBanner from "../components/Banner/OfferBanner";
import FeedbackPortal from "../components/Rating Components/FeedbackPortal";
import Rating from "../components/Rating Components/Rating";
const TypingExamSelection = () => {
  const location = useLocation();
  const [daysRemaining, setDaysRemaining] = useState(null);
  const [expiryMessage, setExpiryMessage] = useState("");
  const [exam, setExam] = useState("");
  const [category, setCategory] = useState("");
  const navigate = useNavigate();
  const [cookies] = useCookies(["token"]);
  const [loading, setLoading] = useState(true);
  const [showMenu, setShowMenu] = useState(false);
  const [isRatingModalOpen, setIsRatingModalOpen] = useState(false);
  const [refreshRating, setRefreshRating] = useState(Date.now());
  const onChangeExam = (e) => setExam(e.target.value);
  const onChangeCategory = (e) => setCategory(e.target.value);
  const gotohome = () => window.open("https://ssccglpinnacle.com", "_blank");
  const gotoBooks = () =>
    window.open("https://books.ssccglpinnacle.com", "_blank");
  const gotoEbooks = () =>
    window.open("https://ebooks.ssccglpinnacle.com", "_blank");
  const gotoTestPortal = () =>
    window.open("https://testportal.ssccglpinnacle.com", "_blank");
  const gotoVideos = () =>
    window.open("https://videos.ssccglpinnacle.com", "_blank");
  const gotoApp = () =>
    window.open(
      "https://play.google.com/store/apps/details?id=com.ssccgl.pinnacle.testportal",
      "_blank"
    );
  const gotoBlogs = () =>
    window.open("https://blogs.ssccglpinnacle.com", "_blank");
  const next = () => {
    if (exam && category) {
      navigate(`/typingparagraph/${exam}/${category}`);
    }
  };

  useEffect(() => {
    const checkAccess = async () => {
      if (!cookies.token) {
        navigate("/" + location.search);
        return;
      }

      try {
        const res = await fetch(
          "https://auth.ssccglpinnacle.com/api/checkAccessTyping",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              Authorization: `Bearer ${cookies.token}`,
            },
          }
        );

        if (!res.ok) return navigate("/" + location.search);

        const { access } = await res.json();
        if (access !== "access") return navigate("/" + location.search);

        const productRes = await fetch(
          "https://auth.ssccglpinnacle.com/api/checkAccessTypingProduct",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              Authorization: `Bearer ${cookies.token}`,
            },
            body: JSON.stringify({ product_id: "999" }),
          }
        );

        if (!productRes.ok) return navigate("/" + location.search);

        const { access: productAccess } = await productRes.json();
        if (productAccess !== "access") return navigate("/" + location.search);

        setLoading(false);
      } catch {
        navigate("/" + location.search);
      }
    };

    checkAccess();
  }, [cookies.token, navigate, location.search]);

  const fetchTypingExpiryAlert = async () => {
    try {
      const email = cookies.userData?.email_id;

      console.log("✅ Email from cookie:", email);

      if (!email) {
        console.warn("⚠️ Email not found in cookies.userData");
        return;
      }

      const response = await fetch(
        "https://auth.ssccglpinnacle.com/api/typing-expiry-remaining",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email_id: email }),
        }
      );

      if (response.ok) {
        const data = await response.json();
        console.log("✅ Typing expiry response:", data);

        if (data.daysRemaining !== null) {
          setDaysRemaining(data.daysRemaining);

          if (data.daysRemaining <= 15) {
            setExpiryMessage(
              `⚠️ Your typing software will expire in ${data.daysRemaining} day(s).`
            );
          } else {
            setExpiryMessage(""); // Clear message if more than 15 days
          }
        }
      } else {
        console.error("❌ API call failed with status:", response.status);
      }
    } catch (err) {
      console.error("❌ Failed to fetch expiry data:", err);
    }
  };

  useEffect(() => {
    fetchTypingExpiryAlert();
  }, [cookies.userData]);

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <p>Checking access...</p>
      </div>
    );
  }

  return (
    <>
      {/* <EbookOfferBanner/> */}
      <div className="min-h-screen bg-white">
        {/* Blue Header */}
        <div className="bg-blue-700 py-3 px-4 flex items-center justify-between">
          <img
            src={pic}
            alt="Logo"
            className="h-5 cursor-pointer"
            onClick={gotohome}
          />
          <p className="flex-1 text-white ml-14 text-sm sm:text-base md:text-lg font-normal text-center">
            Typing Software 2026
          </p>
          <div className=" items-center">
            <Rating
              userId={cookies.userData?._id}
              emailId={cookies.userData?.email_id}
              productId="999"
              onClick={() => setIsRatingModalOpen(true)}
              refreshTrigger={refreshRating}
            />
          </div>
          <div className="w-10 flex justify-end relative group">
            <CgMenuGridO
              size={30}
              className="text-white cursor-pointer"
              onClick={() => setShowMenu(!showMenu)}
            />
            <div className="absolute top-8 mb-2 right-0 bg-blue-900 text-white text-xs rounded px-2 py-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap z-10">
              Pinnacle apps
            </div>
          </div>
        </div>
        {/* Toggleable Menu Card */}
        {showMenu && (
          <div className="absolute right-4 top-20 z-10 bg-white shadow-lg rounded-lg p-4 grid grid-cols-2 gap-4 w-84">
            <div
              className="text-center p-2 border rounded hover:bg-blue-100 cursor-pointer flex items-center justify-center gap-1"
              onClick={gotoBooks}
            >
              {/* <HiOutlineBookOpen /> Books */}
              <img src={book} alt="Books" className="h-10" />
              Books
            </div>
            <div
              className="text-center p-2 border  rounded hover:bg-blue-100 cursor-pointer flex items-center justify-center gap-1"
              onClick={gotoTestPortal}
            >
              {/* <AiOutlineLineChart /> Test Portal */}
              <img src={testSeries} alt="Test Series" className="h-10 " />
              Test Portal
            </div>
            <div
              className="text-center p-2 border rounded hover:bg-blue-100 cursor-pointer flex items-center justify-center gap-1"
              onClick={gotoVideos}
            >
              {/* <MdOndemandVideo /> Videos */}
              <img src={video} alt="Videos" className="h-10" />
              Videos
            </div>
            <div
              className="text-center p-2 border rounded hover:bg-blue-100 cursor-pointer flex items-center justify-center gap-1"
              onClick={gotoEbooks}
            >
              {/* <BsFillMenuButtonWideFill /> eBooks */}
              <img src={ebooks} alt="Ebooks" className="h-10" />
              E-Books
            </div>
            <div
              className="text-center p-2 border rounded hover:bg-blue-100 cursor-pointer flex items-center justify-center gap-1"
              onClick={gotoBlogs}
            >
              {/* <ImBlogger /> Blogs */}
              <img src={blog} alt="Blog" className="h-10" />
              Blogs
            </div>
            <div
              className="text-center p-2 border rounded hover:bg-blue-100 cursor-pointer flex items-center justify-center gap-1"
              onClick={gotoApp}
            >
              {/* <BsGooglePlay /> Google Play */}
              <img src={playIcon} alt="Google Play" className="h-10" />
              Google Play
            </div>
          </div>
        )}
        <FeedbackPortal
          isOpen={isRatingModalOpen}
          onClose={() => setIsRatingModalOpen(false)}
          onFeedbackSubmit={() => setRefreshRating(Date.now())}
          userId={cookies.userData?._id}
          emailId={cookies.userData?.email_id}
          productId="999"
        />
        {/* <Header /> */}
        {/* Black Info Section */}
        <div className="bg-black text-white text-sm  py-4 px-4 sm:px-8 md:px-16 grid grid-cols-1 md:grid-cols-3 gap-4 text-sm sm:text-base">
          <div>
            <p className="font-semibold text-sm">System Name:</p>
            <p className="text-yellow-400 font-bold text-sm">C005</p>
            <p className="text-white text-sm">
              Contact Invigilator if the Name and Photograph display on the
              screen is not yours.
            </p>
          </div>
          <div className="text-center md:col-span-1 flex items-center justify-center">
            <p className="text-white text-sm">
              This typing Software is designed based on the real interface of
              ssc exams.
            </p>
          </div>
          <div className="text-right text-sm">
            <p className="font-semibold">Candidate Name:</p>
            <p className="text-yellow-400 font-bold">User 05</p>
            <p className="text-white text-sm">
              Subject: <span className="text-yellow-300">SSC CGL Tier 2</span>
            </p>
          </div>
        </div>
        {/* Expiry Alert */}
        {expiryMessage && (
          <div className="bg-yellow-100 border border-yellow-400 text-yellow-700 px-4 py-2 rounded mb-4 text-sm text-center">
            {expiryMessage}
          </div>
        )}
        {/* Form Section */}
        <div className="flex justify-center items-center py-12 px-4">
          <div className="bg-blue-50 shadow-md p-6 sm:p-8 rounded w-full max-w-md">
            <h5 className="text-lg font-semibold mb-4 text-center text-gray-700">
              Choose Exam And Category
            </h5>
            <form onSubmit={(e) => e.preventDefault()}>
              <div className="mb-4">
                <select
                  className="w-full p-2 border rounded text-sm"
                  onChange={onChangeExam}
                  required
                >
                  <option value="">Select</option>
                  <option value="CGL">CGL</option>
                  <option value="CHSL">CHSL</option>
                </select>
              </div>
              <div className="mb-4">
                <select
                  className="w-full p-2 border rounded text-sm"
                  onChange={onChangeCategory}
                  required
                >
                  <option value="">Select</option>
                  <option value="UR">UR</option>
                  <option value="OBC">OBC</option>
                  <option value="SC">SC</option>
                  <option value="EWS">EWS</option>
                </select>
              </div>
              <button
                type="button"
                onClick={next}
                className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700 text-sm"
              >
                Next
              </button>
            </form>

            <div className="mt-6 flex justify-center">
              <ShareModal
                product={{
                  id: 999,
                  title: "Typing Pass",
                  price: 299,
                  slug: "typing-pass",
                }}
                userEmail={cookies.userData?.email_id}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TypingExamSelection;
